module.exports = __webpack_public_path__ + "static/essentia_elem_tekst-dfb274d89903aaf1be2c8c5952f517e8.svg";